<mat-card class="mat-title">
    {{shopName}}
</mat-card>
<div *ngIf="!hasError">
    <mat-card *ngIf="hasUnApprovedItems&&userRole=='admin'">
        <button mat-raised-button (click)="approveComissions(true)">Approve Comissions & Allow Rewards</button>
        <button mat-raised-button (click)="approveComissions(false)">Approve Comissions With No Rewards</button>
    </mat-card>

    <mat-card>
        <mat-form-field appearance="fill">
            <mat-label>Defaut Comission</mat-label>
            <input matInput [(ngModel)]="defaultComission" (change)="setComission()">
        </mat-form-field>
    </mat-card>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">


        <!-- Name Column -->
        <ng-container matColumnDef="Ml">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Menu Heading </th>
            <td mat-cell *matCellDef="let element"> {{element.Ml}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Availability">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Availability </th>
            <td mat-cell *matCellDef="let element"> {{element.Availability}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="Price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
            <td mat-cell *matCellDef="let element"><button *ngIf="!element.priceBeingEdited" mat-button
                    (click)="element.priceBeingEdited=true">{{element.Price}}</button>

                <mat-form-field *ngIf="element.priceBeingEdited" style="width: 90px;" appearance="outline">
                    <input [(ngModel)]="element.Price" (click)="$event.target.select()" (change)="setChanged(element)"
                        matInput>
                </mat-form-field>

            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Discount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Discount </th>
            <td mat-cell *matCellDef="let element">

                <button *ngIf="!element.discountBeingEdited" mat-button
                    (click)="element.discountBeingEdited=true">{{element.Discount?element.Discount:0}}</button>
                <mat-form-field *ngIf="element.discountBeingEdited" style="width: 90px;" appearance="outline">
                    <input [(ngModel)]="element.Discount" (click)="$event.target.select()"
                        (change)="setChanged(element)" matInput>
                </mat-form-field>

            </td>
        </ng-container>

        <ng-container matColumnDef="priceAfterDiscount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PAD </th>
            <td mat-cell *matCellDef="let element">
                {{element.Price-element.Discount}}
            </td>
        </ng-container>


        <!-- Symbol Column -->
        <ng-container matColumnDef="cType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
            <td mat-cell *matCellDef="let element">
                <mat-button-toggle-group [(ngModel)]="element.cType" aria-label="Font Style">
                    <mat-button-toggle value="p">%</mat-button-toggle>
                    <mat-button-toggle value="a">&#8377;</mat-button-toggle>
                </mat-button-toggle-group>
            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="proposedComission">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PC </th>
            <td mat-cell *matCellDef="let element">
                <mat-form-field style="width: 50px;" appearance="outline">
                    <input [(ngModel)]="element.proposedComission" (click)="$event.target.select()"
                        (change)="setChanged(element)" matInput>
                </mat-form-field>
            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="effectiveComission">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> EP </th>
            <td mat-cell *matCellDef="let element">
                {{element.cType == "p" ? ((element.Price-element.Discount)-(((element.Price-element.Discount) / 100) *
                element.proposedComission)).toFixed(2) :
                (element.Price-element.Discount)-element.proposedComission}}
            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="approvedComission">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> AC </th>
            <td mat-cell *matCellDef="let element">
                {{element.approvedComission}}
            </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let element"> {{element.status}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
        <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
    </table>


    <mat-card>
        <button mat-raised-button color="primary" (click)="submit()">Submit</button>
    </mat-card>
</div>

<div *ngIf="hasError">
    Error getting details for the product with Id: {{itemIdWithError}}
</div>

<!-- Copyright 2021 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->